import { turpial } from "./turpial";

const parseHtmlString = (string)=>{
    string = string.split("&lt;").join("<");
    string = string.split("&gt;").join(">");

    return string;
}

export {parseHtmlString};